<template>
  <div>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class="tab-content">
      <div class="tab-pane active" id="save_invoice" role="tabpanel">
        <form name="invoice" class="needs-validation" novalidate>
          <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
            <h5><i class="fas fa-pen-nib"></i> Informações da fatura</h5>
          </div>
          <div class="row mb-2">
            <div class="col-md-2">
              <label>ID Fatura</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="data.id"
                  readonly="readonly"
                />
              </div>
            </div>
            <div class="col-md-4" v-if="data.company">
              <label>Cliente</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="data.company.name"
                  readonly="readonly"
                />
              </div>
            </div>
            <div class="col-md-4" v-if="data.customer">
              <label>Cliente</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="data.customer.customerable.name"
                  readonly="readonly"
                />
              </div>
            </div>
            <div class="col-md-3">
              <label>Referente Ao mês</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="data.billing_month"
                  readonly="readonly"
                />
              </div>
            </div>
            <div class="col-md-3">
              <label for="due_date">Vencimento</label>
              <div class="input-group">
                <input
                  id="due_date"
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="data.due_date"
                />
              </div>
            </div>
            <div class="col-md-4 mt-3">
              <label>Status</label>
              <div class="input-group">
                <SelectInvoiceStatuses :selected="data.status" @change="changeStatus" />
              </div>
            </div>
            <div class="col-md-1 mt-3">
              <label>Cancelamento</label>
              <div class="input-group">
                <span class="m-switch m-switch--icon" title="Fatura de cancelamento de contrato">
                  <label>
                    <input
                      type="checkbox"
                      @change="!data.cancellation"
                      name="international"
                      v-model="data.cancellation"
                    />
                    <span></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-9 mt-3">
              <label>Motivo do cancelamento</label>
              <div class="input-group">
                <input
                  type="text"
                  ref="change_reason"
                  class="form-control"
                  maxlength="255"
                  v-model="data.cancel_reason"
                  readonly="readonly"
                  placeholder="Motivo do cancelamento"
                />
              </div>
          </div>
          <div class="alert m-alert m-alert--default col-md-12 mb-12 mt-5" role="alert">
            <h5><i class="fas fa-tags"></i> Modelos de negócios e valores</h5>
          </div>
          <div class="row mb-2">
            <div class="col-md-3">
              <label for="price_extra">Valor Extra</label>
              <div class="input-group">
                <money
                  id="price_extra"
                  v-bind="money"
                  class="form-control m-input"
                  v-model="data.price_extra"
                ></money>
              </div>
            </div>
            <div class="col-md-3">
              <label for="discount">Valor Desconto</label>
              <div class="input-group">
                <money
                  id="discount"
                  v-bind="money"
                  class="form-control m-input"
                  v-model="data.discount"
                ></money>
              </div>
            </div>
            <div class="col-md-3">
              <label>Valor Total</label>
              <div class="input-group">
                <money
                  v-bind="money"
                  class="form-control m-input"
                  :value="data.price_total + data.price_extra - data.discount"
                  readonly="readonly"
                ></money>
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="data.discount > 0">
            <div class="col-md-12">
              <label for="product_id"
                >Motivo do desconto<span class="m--font-danger">*</span></label
              >
              <div class="input-group">
                <div class="input-group">
                  <SelectDiscountReasons
                    id="discount_reason_id"
                    ref="discount_reason_id"
                    :first="'Selecione um motivo'"
                    @change="updateReasonIdValue($event)"
                    :selected="data.discount_reason_id"
                    v-model="data.discount_reason_id"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="data.price_extra > 0">
            <div class="col-md-12">
              <label for="product_id"
                >Motivo do valor extra<span class="m--font-danger">*</span></label
              >
              <div class="input-group">
                <div class="input-group">
                  <SelectExtraReasons
                    id="extra_reason_id"
                    ref="extra_reason_id"
                    :first="'Selecione um motivo'"
                    @change="updateExtraIdValue($event)"
                    :selected="data.extra_reason_id"
                    v-model="data.extra_reason_id"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="alert m-alert m-alert--default mb-3 mt-5" role="alert">
            <h5><i class="fas fa-file-alt"></i> Observações</h5>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <div class="input-group">
                <textarea
                  v-bind="money"
                  class="form-control ng-empty"
                  v-model="data.note"
                ></textarea>
              </div>
            </div>
          </div>
          <hr class="row mt-5 mb-3" />
          <div class="row">
            <div class="col-md-12 text-right">
              <p class="p-0 m-0">
                <a
                  href="#"
                  @click.prevent="$refs.discount_reason_id.focus()"
                  target="_self"
                  class="m--font-danger"
                  v-if="data.discount > 0 && !data.discount_reason_id"
                  >O campo <strong>Motivo do desconto</strong> é obrigatório para aplicar
                  desconto</a
                >
              </p>
              <p class="p-0 m-0">
                <a
                  href="#"
                  @click.prevent="$refs.extra_reason_id.focus()"
                  target="_self"
                  class="m--font-danger"
                  v-if="data.price_extra > 0 && !data.extra_reason_id"
                  >O campo <strong>Motivo do valor extra</strong> é obrigatório para aplicar valor
                  extra</a
                >
              </p>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-12 text-right">
              <button
                @click.prevent="saveForm()"
                class="btn"
                :class="{
                  'btn-metal': !formIsValid,
                  'btn-success': formIsValid,
                }"
                :disabled="!formIsValid"
              >
                Salvar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectInvoiceStatuses from '@/components/forms/SelectInvoiceStatuses';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import SelectDiscountReasons from '@/components/forms/SelectDiscountReasons';
import SelectExtraReasons from '@/components/forms/SelectExtraReasons';

export default {
  mixins: [returnMessageFormMixin],
  name: 'InvoiceSave',
  components: {
    SelectInvoiceStatuses,
    Money,
    SelectDiscountReasons,
    SelectExtraReasons,
  },
  props: {
    invoiceId: Number,
  },
  data() {
    return {
      data: {
        discount_reason_id: 0,
        price_extra: 0,
        discount: 0,
        company: {
          name: '',
        },
        customer: {
          customerable: {
            name: '',
          },
        },
        cancellation: false,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      dialog: '',
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    changeStatus(status) {
      this.data.status = status;
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;

      const url = `${baseApiUrl}/v1/invoice/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.$emit('savedInvoice');
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getData() {
      const url = `${baseApiUrl}/v1/invoice/data/${this.invoiceId}`;
      axios(url).then((res) => {
        const { data } = res;

        data.price_extra = data.price_extra || 0;
        data.discount = data.discount || 0;

        this.data = data;
      });
    },
    updateReasonIdValue(reasonId) {
      this.data.discount_reason_id = reasonId;
    },
    updateExtraIdValue(reasonId) {
      this.data.extra_reason_id = reasonId;
    },
  },
  computed: {
    formIsValid() {
      if (
        (this.data.discount == 0 && this.data.price_extra == 0) ||
        (this.data.discount > 0 && this.data.discount_reason_id && this.data.price_extra == 0) ||
        (this.data.price_extra > 0 && this.data.extra_reason_id && this.data.discount == 0) ||
        (this.data.discount > 0 &&
          this.data.discount_reason_id &&
          this.data.price_extra > 0 &&
          this.data.extra_reason_id)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style></style>
